import { PureComponent } from 'react';
import i10n from '../../common/i10n'

export class Merchandizer extends PureComponent {

    getLink(tool) {
        if (tool.merchandise && tool.merchandise.link)
            return `${tool.merchandise.link}?utm_source=avepdf&utm_medium=referral&utm_campaign=tools&utm_content=${tool.route}`
        return null;
    }

    getLink2(tool) {
        if (tool.merchandise2 && tool.merchandise2.link)
            return `${tool.merchandise2.link}`
        return null;
    }

    render() {
        var link = this.getLink(this.props.tool);
        var link2 = this.getLink2(this.props.tool);
        if (link && link2){
            return (
                <div className="row ave-row-medium">
                    <div className="col">
                        <div className="tool-powered-by">
                            <span>Powered by <a href={link} target="_blank">{this.props.tool.merchandise.title}</a> | {i10n._VIEW_LAYOUT_TOOL_MERCH_PSPDFKIT} - <a href={link2} target="_blank">{this.props.tool.merchandise2.title}</a></span>
                        </div>
                    </div>
                </div>
            );
        }
        return <></>
            
    }
}